export default __webpack_public_path__ + "static/media/contact-us-image.4f35e3b4.png";